interface FileIconProps {
  extension: string
  size?: number
  className?: string
}

/**
 * File icon component that loads SVG icons from public/assets/file icons/
 * Uses Untitled UI file icons for consistent design
 */
export function FileIcon({ extension, size = 32, className }: FileIconProps) {
  // Normalize extension to lowercase
  const ext = extension.toLowerCase()

  // Build icon path
  const iconPath = `/assets/file icons/${ext}.svg`
  const defaultIconPath = '/assets/file icons/default.svg'

  return (
    <img
      src={iconPath}
      alt={`${ext} file icon`}
      width={size}
      height={size}
      className={className}
      onError={(e) => {
        // Fallback to default icon if specific icon doesn't exist
        const target = e.target as HTMLImageElement
        if (target.src !== defaultIconPath) {
          target.src = defaultIconPath
        }
      }}
      style={{
        display: 'block',
        objectFit: 'contain',
      }}
    />
  )
}
